module.exports = __webpack_public_path__ + "static/university-of-manchester-logo-4bd8204805a93dc40c8b467d654352e7.png";